let starSvg =
  '<svg width="15" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 14"><path d="M7.49997,0.0001v0l2.47177,4.39923v0l5.02723,0.94783v0l-3.4995,3.66659v0l0.63521,4.98562v0l-4.63471,-2.13371v0l-4.63482,2.13371v0l0.63521,-4.98562v0l-3.49939,-3.66659v0l5.02712,-0.94783v0l2.47188,-4.39923v0"></path></svg>';
$(function() {
  $(".rating-item").each(function() {
    let rating = $(this).data("rating");
    $(this).rateYo({
      rating: rating,
      starSvg: starSvg,
      normalFill: "#c4cacb",
      ratedFill: "#4a91e3",
      readOnly: true,
      starWidth: "15px",
      spacing: "4px"
    });
  });
  $(".default-select").niceSelect();
  // let dotdotdotOptions = {
  //   ellipsis: " ...",
  //   height: 100
  // };
  // document.querySelectorAll(".review__text p").forEach(function(value) {
  //   new Dotdotdot(value, dotdotdotOptions);
  // });
  $(".header__mobile-ico").on("click", function(e) {
    e.preventDefault();
    $(".mobile-menu").addClass("active");
  });
  $(".mobile-menu__close").on("click", function(e) {
    $(".mobile-menu").removeClass("active");
  });
  $(window).on("resize", function() {
    if ($(window).width() - getScrollbarWidth() > 1040) {
      if ($(".mobile-menu").hasClass("active")) $(".mobile-menu").removeClass("active");
    }
  });
  $(".register-modal__form").validate({
    rules: {
      email: {
        required: true
      },
      password: {
        required: true
      }
    },
    submitHandler: function(form) {
      var formData = $(form).serializeArray();
      $.ajax({
        url: "/send.php",
        method: "POST",
        data: formData,
        success: function() {
          console.log(formData);
        }
      });
    }
  });
  $(".search-modal__form").validate({
    rules: {
      request: {
        required: true
      }
    },
    submitHandler: function(form) {
      var formData = $(form).serializeArray();
      $.ajax({
        url: "/send.php",
        method: "POST",
        data: formData,
        success: function() {
          console.log(formData);
        }
      });
    }
  });
});
if ($("#map").length) {
  ymaps.ready(function() {
    var myMap = new ymaps.Map("map", {
        center: [55.751574, 37.573856],
        zoom: 14,
        controls: []
      }),
      myPlacemark = new ymaps.Placemark(
        [55.751574, 37.573856],
        {
          hintContent: "Минск, ул. Уручская, 23А"
        },
        {
          // Опции.
          // Необходимо указать данный тип макета.
          iconLayout: "default#image",
          // Своё изображение иконки метки.
          iconImageHref: "img/map-marker.png",
          // Размеры метки.
          iconImageSize: [86, 86],
          // Смещение левого верхнего угла иконки относительно
          // её "ножки" (точки привязки).
          iconImageOffset: [-5, -38]
        }
      );
    let routeButton;
    myMap.container.fitToViewport();
    $(".about-main__road").on("click", function(e) {
      e.preventDefault();
      let type = this.getAttribute("data-type");
      if (!routeButton) {
        routeButton = new ymaps.control.RouteButton({
          options: {
            size: "small"
            // collapseOnBlur: false,
          },
          state: {
            // expanded: true
          }
        });
        myMap.controls.add(routeButton);
        routeButton.routePanel.options.set({
          types: {
            auto: true,
            masstransit: true,
            pedestrian: false,
            bicycle: false,
            taxi: false
          }
        });
      }
      routeButton.state.set({
        expanded: true
      });
      routeButton.routePanel.state.set({
        from: "",
        to: "Минск, ул. Уручская, 23А",
        type: type
      });
    });

    myMap.geoObjects.add(myPlacemark);
  });
}

function getScrollbarWidth() {
  var outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.width = "100px";
  outer.style.msOverflowStyle = "scrollbar";

  document.body.appendChild(outer);

  var widthNoScroll = outer.offsetWidth;
  // force scrollbars
  outer.style.overflow = "scroll";

  // add innerdiv
  var inner = document.createElement("div");
  inner.style.width = "100%";
  outer.appendChild(inner);

  var widthWithScroll = inner.offsetWidth;

  // remove divs
  outer.parentNode.removeChild(outer);
  return widthNoScroll - widthWithScroll;
}

var mac = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? true : false;

function modalOpenMac() {
  // console.log("open", mac);
  if (mac) {
    if ($(document).height() > $(window).height() && !$("html").hasClass("apple-fix")) {
      var scrollTop = $("html").scrollTop() ? $("html").scrollTop() : $("body").scrollTop(); // Works for Chrome, Firefox, IE...
      $("html").css("top", -scrollTop);
      document.documentElement.classList.add("apple-fix");
    }
  }
}

function modalCloseMac() {
  // console.log("close", mac);
  if (mac) {
    var scrollTop = parseInt($("html").css("top"));
    document.documentElement.classList.remove("apple-fix");
    $("html,body").scrollTop(-scrollTop);
  }
}

function hasScrollbar() {
  // console.log(document.body.scrollHeight, document.body.clientHeight);
  // return document.body.scrollHeight > document.body.clientHeight;
  // console.log($(document).height() > $(window).height());
  return $(document).height() > $(window).height();
}
